import { gsap } from "gsap";
import { mobileToggle$ } from "../lib/state";
import { BinaryString } from "../lib/types";

class ToggleSlider extends HTMLInputElement {
  #abortController: AbortController | null;
  #mobileToggle = false;

  constructor() {
    super();
    this.type = 'range';
    this.min = '0';
    this.max = '1';
    this.step = '0.1';
  }

  connectedCallback(): void {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.addEventListener('pointerdown', (e) => this.#onPointerDown(e), { signal });
    this.addEventListener('input', () => {
      if (this.dataset.value !== this.value) this.dataset.value = this.value;
      if (this.#mobileToggle) mobileToggle$.next(this.value as BinaryString);
    }, { signal });
    setTimeout(() => {
      this.#emitEvent();
    }, 200);
    
  }

  disconnectedCallback(): void {
    this.#abortController?.abort();
    this.#abortController = null;
  }
  
  static get observedAttributes(): string[] {
    return ['mobile-toggle'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === 'mobile-toggle') {
      this.#mobileToggle = newValue === 'true';
      if (this.#mobileToggle) this.setAttribute('value', mobileToggle$.value);
    }
  }

  #onPointerDown(e: PointerEvent) {
    e.preventDefault();
    const start = this.valueAsNumber;
    const end = start === 1 ? 0 : 1;
    this.dataset.value = end.toString();
    gsap.fromTo(this, 
      { 
        valueAsNumber: start 
      },
      {
        valueAsNumber: end, 
        step: 0.1, 
        duration: 0.2, 
        ease: 'power2.out',
        onComplete: () => this.#emitEvent()
      });
  }

  #emitEvent() {
    this.dispatchEvent(new Event('input'));
    this.setAttribute('value', this.value);
  }
}

customElements.define('toggle-slider', ToggleSlider, { extends: 'input' });